import axios from 'axios'
import { Message } from 'iview'
import qs from 'Qs'

let website = 'https://demo.huobianli.cn/index.php?'
// let website = window.location.protocol + '//' + window.location.host + '/index.php?'
// https://demo.huobianli.cn

export default {
  post(url, param) {
    return new Promise((cback, reject) => {
      if (param == undefined) param = {}
      param.shopid = this.getCookie('cook_ShopId')
      param.cus_uid = this.getCookie('cook_cus_uid')
      param.cus_pwd = this.getCookie('cook_cus_pwd')
      axios({
        url: website + url + "&datatype=json",
        method: 'post', 
        data: qs.stringify(param)
      })
      .then(response => {
        if (response.status === 200) {
          // console.log(response)
          if (!response.data.error) {
            cback(response);
          } else {
            reject(response.data.msg);
          }
        } else {
          reject(response)
        }
      })
      .catch(error => {
        reject(error);
      })
    })
  },
  getCookie(name) {
    // let arr;
    // let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    // console.log(document.cookie.match(reg))
    // if (arr == document.cookie.match(reg)) {
    //   console.log(arr[2])
    //   return arr != undefined ? arr[2] : null
    //   // return unescape(arr[2])
    // } else {
    //   return null;
    // }

    let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");

    if(arr = document.cookie.match(reg)) {
      return unescape(arr[2])
    } else {
      return null
    }
    // if (name == 'cook_ShopId') return 317
    // if (name == 'cook_cus_uid') return 32
    // if (name == 'cook_cus_pwd') return 123456
  }
}


// WEBPACK FOOTER //
// ./src/request/http.js